
export const eventValue = (cb: (v: string) => void) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  return cb(e.target.value);
};